import { gql } from "gql";

export const GET_CRUD_ENTITY_VALUES = gql(/* GraphQL*/ `
  query GetCrudEntityValues ($entity: CrudListEntities!) {
    getAllCrudEntityValues(entity:$entity) {
      id
      name
    }
  }
`);
